export default {
  EVENT_DETAIL_LIST_REQUEST: 'APP/EVENT_DETAIL/EVENT_DETAIL_LIST_REQUEST',
  EVENT_DETAIL_LIST_SUCCESS: 'APP/EVENT_DETAIL/EVENT_DETAIL_LIST_SUCCESS',
  EVENT_DETAIL_LIST_ERROR: 'APP/ EVENT_DETAIL/EVENT_DETAIL_LIST_ERROR',
};
